import React from 'react';
import { useEffect } from 'react';
import Navbar2 from '../Navbar2';
import Footer from '../Footer';
import ContactHero from '../ContactHero';
import ContactForm from '../ContactForm';
import ReactGA from 'react-ga';

const TRACKING_ID = 'G-PRDSTPVCDN';
ReactGA.initialize(TRACKING_ID);

function ContactPage() {
  useEffect(() => {
    document.title = 'JOBS4US - Contact';
  }, []);
  return (
    <div>
      <Navbar2 />
      <ContactHero />
      <ContactForm />
      <Footer />
    </div>
  );
}

export default ContactPage;
